
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/money-fortune/V",
      function () {
        return require("private-next-pages/money-fortune/V.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/money-fortune/V"])
      });
    }
  